module.exports = __webpack_public_path__ + "img/Credencial-A.aeb47472.svg";